// 🍕 GOLDEN PIZZA HUNT — a hidden daily pizza marker on the map during FEAST events.
import { useEffect, useRef } from "react";
import L from "leaflet";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useGoldenPizzaHunt(mapRef, driver) {
  const markerRef = useRef(null);
  const driverRef = useRef(driver);
  driverRef.current = driver;

  useEffect(() => {
    let cancelled = false;
    let tries = 0;
    const arm = () => {
      const map = mapRef.current;
      if (cancelled) return;
      if (!map) {
        if (tries++ < 20) setTimeout(arm, 1500);
        return;
      }
      const c = map.getCenter();
      axios.get(`${API}/hunt/today`, { params: { lat: c.lat, lng: c.lng } }).then((r) => {
        if (cancelled || !r.data.active || r.data.claimed || markerRef.current) return;
        const hunt = r.data;
        // 🍕 teaser nudge — once per day when the zone's pizza is unclaimed
        const tKey = `airpog_hunt_teaser_${hunt.day}`;
        if (!localStorage.getItem(tKey)) {
          localStorage.setItem(tKey, "1");
          toast("🍕✨ A GOLDEN PIZZA is hiding near you — find the glowing gold pin on the map and tap it FIRST!", { duration: 7000 });
        }
        const icon = L.divIcon({
          className: "golden-pizza-pin",
          html: `<div style="position:relative;width:34px;height:34px" title="GOLDEN PIZZA — first POG'R to tap it wins!">
                   <span class="animate-ping" style="position:absolute;inset:0;border-radius:9999px;background:rgba(251,191,36,0.55)"></span>
                   <span style="position:absolute;inset:2px;border-radius:9999px;background:linear-gradient(135deg,#f59e0b,#fbbf24);box-shadow:0 0 14px 4px rgba(251,191,36,0.8);display:flex;align-items:center;justify-content:center;font-size:16px">🍕</span>
                 </div>`,
          iconSize: [34, 34], iconAnchor: [17, 17],
        });
        markerRef.current = L.marker([hunt.lat, hunt.lng], { icon, zIndexOffset: 1200 }).addTo(map);
        markerRef.current.on("click", async () => {
          if (!driverRef.current) { toast("🍕 Sign in to claim the GOLDEN PIZZA!"); return; }
          try {
            const res = await axios.post(`${API}/hunt/claim`, { lat: hunt.lat, lng: hunt.lng }, { withCredentials: true });
            toast.success(`🍕✨ GOLDEN PIZZA CLAIMED! +${res.data.bucks} POG BUCKS and the LEGENDARY pog is YOURS!`, { duration: 8000 });
            markerRef.current?.remove();
            markerRef.current = null;
          } catch (e) {
            toast.error(e?.response?.data?.detail || "The pizza slipped away!");
          }
        });
      }).catch(() => {});
    };
    arm();
    return () => { cancelled = true; markerRef.current?.remove(); markerRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
